import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedSection } from './components/IncludedSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { ClosingSection } from './components/ClosingSection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','849770337749853');fbq('track','PageView');`;
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=849770337749853&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white text-gray-900" data-id="element-0">
      <UrgencyBanner data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <IncludedSection data-id="element-6" />
        <BeforeAfterSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <PricingSection data-id="element-9" />
        <GuaranteeSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <ClosingSection data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
      <SocialProofPopup data-id="element-15" />
      <FloatingCTA data-id="element-16" />
    </div>;
}